import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  ActivityIndicator,
} from "react-native";
import { currencyFormatter, dateFormatter } from "@lib/utilities/Formatters";
import {
  DROP_DOWN_ARROW_ICON,
  DROP_UP_ARROW_ICON,
} from "../../resources/IMAGES";
import { BillingConstants } from "@lib/utilities/Constants";
import commonStyle from "../../assets/styles/common-style";
import { styles, ids } from "./Style";
import { Payments } from "@lib/hooks/billing/billingPaymentParser";
import { PaymentStatusInfo } from "../common/PaymentStatusInfo/PaymentStatusInfo";
import { theme } from "../../theme/theme";
import { useAppSelector } from "@lib";

interface PaymentsListProps {
  paymentsArray: Payments[];
  expandedIndex: number;
  toggleExpandedView: (index: number) => void;
  getTotalPaymentAmount: () => number;
}

const PaymentsList: React.FC<PaymentsListProps> = ({
  paymentsArray,
  expandedIndex,
  toggleExpandedView,
  getTotalPaymentAmount,
}) => {
  const { paymentsLoading } = useAppSelector(
    (state) => state.policyDetailReducer,
  );

  return (
    <View>
      <View
        style={[commonStyle.styles.rowFlex, styles.listHeadingTop]}
        dataSet={{ media: commonStyle.ids.rowFlex }}
        testID={"billing-page-payments-list-header-container"}
      >
        <Text
          style={[styles.headingText]}
          dataSet={{ media: ids.headingText }}
          testID="billing-page-payments-list-header"
        >
          {BillingConstants.payments}
        </Text>
      </View>
      <View style={styles.paymentStatusView} testID="billing-page-payment-status-container">
        <Text style={styles.paymentStatusText} testID="billing-page-payment-status-label">
          {BillingConstants.paymentStatusLabel}
        </Text>
      </View>
      <View
        style={[styles.policyHolderContainer]}
        dataSet={{ media: ids.policyHolderContainer }}
        testID="billing-page-payments-values-list-container"
      >
        {paymentsLoading ? (
          <ActivityIndicator
            color={theme.colors.primary}
            size={theme.spacing.xlg}
            style={styles.activityIndicator}
          />
        ) : paymentsArray.length > 0 ? (
          paymentsArray.map((payment: any, index: number) => (
            <View key={index}>
              <View
                style={[commonStyle.styles.colFlex, styles.listItem]}
                dataSet={{ media: commonStyle.ids.colFlex }}
                testID={`billing-page-payment-dropdown-button-container`}
              >
                <TouchableOpacity onPress={() => toggleExpandedView(index)} testID={`billing-page-payment-dropdown-button`}>
                  <View
                    style={[commonStyle.styles.rowFlex, styles.justifyContent]}
                    dataSet={{ media: commonStyle.ids.rowFlex }}
                  >
                    <Text
                      style={[styles.labelText, styles.textLabel]}
                      dataSet={{ media: ids.labelText }}
                      testID={`billing-page-payment-date-label`}
                    >
                      {dateFormatter(payment.date)}
                    </Text>
                    <View
                      style={[
                        commonStyle.styles.rowFlex,
                        commonStyle.styles.inMiddle,
                      ]}
                      dataSet={{ media: commonStyle.ids.rowFlex }}
                    >
                      <Text
                        style={[styles.descText]}
                        dataSet={{ media: ids.descText }}
                        testID={`billing-page-payment-amount`}
                      >
                        {currencyFormatter(payment.amount)}
                      </Text>
                      <View
                        style={styles.expandArrow}
                        dataSet={{ media: ids.expandArrow }}
                        testID={`billing-page-payment-toggle-container`}
                      >
                        <Image
                          tintColor={"black"}
                          testID={`billing-page-payment-toggle-button-image`}
                          style={[styles.arrowDown]}
                          dataSet={{ media: ids.arrowDown }}
                          source={
                            expandedIndex == index
                              ? DROP_UP_ARROW_ICON
                              : DROP_DOWN_ARROW_ICON
                          }
                        />
                      </View>
                    </View>
                  </View>
                </TouchableOpacity>
                {expandedIndex == index && (
                  <View
                    style={[
                      commonStyle.styles.rowFlex,
                      styles.expandData,
                      styles.flexGrow,
                      styles.justifyContent,
                    ]}
                    dataSet={{ media: commonStyle.ids.rowFlex }}
                  >
                    <Text
                      style={[styles.labelText, styles.textLabel]}
                      dataSet={{ media: ids.labelText }}
                      testID={`billing-page-payment-type`}
                    >
                      {payment.type}
                    </Text>
                    <Text
                      style={[styles.descText, styles.labelValue]}
                      dataSet={{ media: ids.descText }}
                      testID={`billing-page-payment-description`}
                    >
                      {payment.description}
                    </Text>
                  </View>
                )}
              </View>
              <View style={styles.divider} />
              {index == paymentsArray.length - 1 && (
                <View
                  style={[commonStyle.styles.colFlex, styles.listItem]}
                  dataSet={{ media: commonStyle.ids.colFlex }}
                >
                  <View
                    style={[
                      commonStyle.styles.rowFlex,
                      styles.paymentReceivedDate,
                      styles.justifyContent,
                    ]}
                    dataSet={{ media: commonStyle.ids.rowFlex }}
                  >
                    <Text
                      style={[styles.descText, styles.textLabel]}
                      dataSet={{ media: ids.descText }}
                    />
                    <View
                      style={[
                        commonStyle.styles.rowFlex,
                        commonStyle.styles.inMiddle,
                      ]}
                      dataSet={{ media: commonStyle.ids.rowFlex }}
                    >
                      <Text
                        style={[styles.WhiteBoldText, styles.descText]}
                        dataSet={{ media: ids.descText }}
                        testID={`billing-page-payments-received-amount-value`}
                      >
                        {BillingConstants.paymentsReceived}:{" "}
                        {currencyFormatter(getTotalPaymentAmount())}
                      </Text>
                    </View>
                  </View>
                </View>
              )}
            </View>
          ))
        ) : (
          <PaymentStatusInfo />
        )}
      </View>
    </View>
  );
};

export default PaymentsList;
